import { LoginPage } from "@/features/auth";

export default function Login() {
  return <LoginPage />;
}
